import 'babel-polyfill'
import '../../javascripts/front/application';
import '../../stylesheets/front/application';

require.context('../../images', true, /\.(png|jpg|jpeg|svg)$/);

console.log('Front from Webpacker');
